import { nFormatter } from "utils/parseNumber";

import LIKED_ICON from "components/icons/likeIcon.svg";
import UNLIKED_ICON from "components/icons/unliked.svg";

export const LikeButton = (props: {
  liked: boolean;
  count: number;
  onClick: () => void;
}): JSX.Element => {
  return (
    <div className="likes">
      <img
        src={props.liked ? LIKED_ICON : UNLIKED_ICON}
        onClick={props.onClick}
        alt=""
      />
      <div className="label">{nFormatter(props.count)}</div>
    </div>
  );
};
